import { FC } from 'react'
import {
    SwitchContainer,
    SwitchRoot,
    SwitchInput,
    SwitchTrack,
    SwitchThumb,
    SwitchText,
} from './Switch.styles'
import CircleIndicator from '@components/circle-indicator'
import { SwitchProps } from './Switch.types'

const Switch: FC<SwitchProps> = ({
    checked,
    disabled,
    onChange,
    text,
    loading,
    name = 'switch-text',
    testId = 'switch',
    ...rest
}) => {
    return (
        <SwitchContainer>
            <SwitchRoot disabled={loading || disabled}>
                <SwitchInput
                    type="checkbox"
                    checked={checked}
                    onChange={onChange}
                    disabled={loading || disabled}
                    data-testid={testId}
                    {...rest}
                />
                <SwitchTrack checked={checked} />
                <SwitchThumb checked={checked} />
            </SwitchRoot>
            {loading && <CircleIndicator loading size={21} width={2} />}
            {text && !loading && (
                <SwitchText data-testid={name} isOn={checked}>
                    {checked ? text.on : text.off}
                </SwitchText>
            )}
        </SwitchContainer>
    )
}

export default Switch
